// extracted by mini-css-extract-plugin
export default {"button":"Button_button__f4MbK","label":"Button_label__uM0L-"};